import { CouponDocument } from './coupon.model';
import { ContainerImageModel } from '@app/models/server/layout.model';
import { SelectedDateModel } from '@app/models/client/request-body.model';

export class UserModel {
  _id: string;
  uid: string;
  displayName: string;
  firstName: string;
  lastName: string;
  emailId: string;
  address: string;
  gender: string;
  type: string;
  photoUrl: string;
  roles: any;
  mobileNo: string;
  sendNotificationOnWhatsApp?: boolean;
  dob: Date;
  age: number;
  countryCode: string;
  country: string;
  emailVerified: boolean;
  loginType: string;
  mobileOrEmail: string;
  totalBookings: number;
  totalShortstayBookings: number;
  totalLongstayBookings: number;
  wishlistPropertyIds: string[];
  membershipInfo: MembershipSettingsModel;
  creditPointInfo: CreditPointSettingsDocument;
  // currentMembershipData: MembershipDbDocument;
  // nextMembershipData: MembershipDbDocument;
  // previousMembershipData: MembershipDbDocument;
  coupons: CouponDocument[] = [];
  stdCode: string;
  countryIsoCode: string;
  fb_uid: string;
  termsAccepted: boolean;
  // client properties
  password: string;
  confirmPassword: string;
  // otp: number;

  // new fields
  areYouTravellingForWork: string;
  whoAreYouBookingFor: string;
  youArrivalTime: string;
  comment?: string;
  howDidYouHearAboutUs?: string;
  registrationNumber?: string;
  registeredCompanyName?: string;
  registeredCompanyAddress?: string;

  activeMembershipInfo: ActiveMembershipInfoData;

  bookingInfo: {
    totalBookings: number;
    totalShortstayBookings: number;
    totalExtendedStayBookings: number;
    totalExtendedStayNights: number;
  };
  referralCode: string;
  earnedByReferring: UserEarningsByReferringData;
  userCouponConfig: UserCouponConfigData[];
  userReferralInfo: UserReferralInfoData;

  isNewUser: boolean;
}

export class UserCouponConfigData {
  parentCouponId: string;
  orderId: number;
  childCoupons: UserCoupon[];
}

export class UserCoupon {
  couponId?: string;
  couponTitle?: string;
  couponCode?: string;
  couponType?: string;
  startDate?: SelectedDateModel;
  endDate?: SelectedDateModel;
}

export class UserEarningsByReferringData {
  creditPoints: number;
  creditPointValue: number;
}

export class MembershipSettingsModel {
  _id: string;
  membershipTitle: string;
  membershipType: string;
  oneCreditPointValue: number;
  membershipUpdatedDate: string | Date;
}

export class CreditPointSettingsDocument {
  _id: string;
  creditPoints: number;
  creditPointExpiryDate: Date | string;
  creditPointModifiedDate: Date | string;
}

/*export interface MembershipDbDocument {
  _id: string;
  imagePath: string;
  title: string;
  membershipType: string;
  type: string;
  benefits: string[];
  oneCreditPointValue: number;
  grantXCreditPoints: number;
  forEveryYBucks: number;
  criterias: CriteriasRefDbModel;
  isActive: boolean;
  validity: number;
}*/

/*export class CriteriasRefDbModel {
  // minBookingsCriteria: number,
  // maxBookingsCriteria: number,
  _id: string;
  bookingCountToUpdateLevel: number;
  maxDaysToUpdateLevel: number; // this will be date
  bookingCountToRetainLevel: number;
  maxDaysToRetainLevel: number;
  freeCancellationHoursBeforeCheckin: number; // hours
}*/

export class ActiveMembershipInfoData {
  _id?: string;

  activeMembershipTitle: string;

  activeMembershipType: string;

  createdDate: Date;

  startDate: Date;

  expiredDate: Date;

  isPaid: boolean;

  membershipOrderId: number;

  membershipOrderUID: string;

  oneTimeDiscount: number;

  firstNBookingsCount: number;
}

export class UserReferralInfoData {
  _id?: string;
  primaryReferralCode: string;
  registeredWithReferralCode: string;
  usedReferralCodes: string[];
}

export type MembershipConstantsType = {
  title: string;
  type: string;
  image: ContainerImageModel;
  retainMembership?: {
    extendedStay: { durationInDays: number; nights: number };
    shortStay: { durationInDays: number; bookings: number };
  };
  benefits?: {
    customerSupport: string;
    accountManager: string;
    oneTimeFreeCreditPoints: number;
    welComeGift: string;
    surpriseOffer: string;
    cancellation: string;
    firstNNightBookingCount: number;
    firstNNightDiscountPercentage: number;
    firstNNightDiscountPercentageUptoInr: number;
    rewards: string[];
  };
  textList: string[];
  creditPoint?: {
    expireInDays: number;
    earnOnWeb: number;
    earnOnMobileApp: number;
    algorithmData: {
      creditPointValue: number;
      oneCreditPontPerInr: number;
    };
  };
  upgradeToNextLevel?: {
    extendedStay: { durationInDays: number; nights: number };
    shortStay: { durationInDays: number; bookings: number };
  };
};
